export const baseURL = process.env.REACT_APP_BASE_URL || '';
export const authURL = process.env.REACT_APP_AUTH_URL || '';
export const apiKey = process.env.REACT_APP_API_KEY || '';

export const QR_BASE_URL = process.env.REACT_APP_QR_BASE_URL || '';
export const APP_PROTOCOL = process.env.REACT_APP_APP_PROTOCOL || '';
export const tenantName = process.env.REACT_APP_TENANT_NAME || '';
